import { createSlice } from '@reduxjs/toolkit';
import { REDUX_OPERATIONS } from '../reduxConstants';

const initialState = {
  chargeItem: [],
};

const invoiceSlice = createSlice({
  name: 'invoiceSlice',
  initialState,
  reducers: {
    setChargeItem: (state, action) => {
      let chargeItemList = [...state.chargeItem];
      if (
        action.payload?.operation === REDUX_OPERATIONS.UPDATE &&
        chargeItemList.some(s => s.sequence === action.payload?.sequence)
      ) {
        chargeItemList[
          chargeItemList.findIndex(f => f.sequence === action.payload?.sequence)
        ] = action.payload?.chargeItems;
      } else if (action.payload?.operation === REDUX_OPERATIONS.DELETE) {
        chargeItemList = chargeItemList.filter(
          f => f.sequence !== action.payload?.sequence
        );
      } else if (action.payload?.operation === REDUX_OPERATIONS.ADD) {
        chargeItemList.push(action.payload.chargeItems);
      }
      state.chargeItem = [
        ...chargeItemList.map((d, idx) => {
          return {
            ...d,
            sequence: idx + 1,
          };
        }),
      ];
    },
    clearChargeItem: state => {
      state.chargeItem = [];
    },
  },
});

export const { setChargeItem, clearChargeItem } = invoiceSlice.actions;

export default invoiceSlice.reducer;
